// Uses crypto.randomUUID() when available, falling back to Math.random()
// NOTE: The fallback is not cryptographically secure and should not be used
// for security-critical identifiers like session tokens or encryption keys
export const generateRandomId = (): string => {
  if (self?.crypto?.randomUUID) {
    return self?.crypto?.randomUUID();
  }

  return Math.floor((Math.random() * 1000000000000) % 1000000000000).toString();
};
